var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "footer-wrapper" },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "footer-top-wrapper",
                  staticStyle: { display: "flex", "flex-direction": "row" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "justify-content": "flex-start"
                      },
                      attrs: { span: 6 }
                    },
                    [
                      _c("div", { staticClass: "footer-logo" }, [
                        _c("img", {
                          staticClass: "unifi-logo-svg cursor-pointer",
                          staticStyle: {
                            height: "48px",
                            "margin-bottom": "29px"
                          },
                          attrs: {
                            alt: "",
                            src: require("../../assets/unifi-logo-new-with-text-white.svg")
                          },
                          on: { click: _vm.redirectToHome }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center"
                      },
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "footerText",
                          staticStyle: {
                            "margin-top": "6.5px",
                            "padding-right": "10px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s("\u00A9 " + new Date().getFullYear()) +
                              " UNIFI Property, All rights reserved\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            width: "30px",
                            height: "30px"
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.facebook.com/unifiproperty",
                                target: "_blank"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "object-fit": "cover",
                                  width: "100%",
                                  height: "100%"
                                },
                                attrs: {
                                  alt: "Facebook",
                                  src: require("../../../static/img/facebook48x48.png")
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            width: "30px",
                            height: "30px"
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.instagram.com/unifiproperty/",
                                target: "_blank"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "object-fit": "cover",
                                  width: "100%",
                                  height: "100%"
                                },
                                attrs: {
                                  alt: "Intagram",
                                  src: require("../../../static/img/instagram48x48.png")
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "justify-content": "flex-end",
                        "align-items": "center"
                      },
                      attrs: { span: 6 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "footer-state-btn",
                          on: { click: _vm.openPrivacyPolicy }
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "footer-state-btn",
                          on: { click: _vm.openTnC }
                        },
                        [_vm._v("Terms & Conditions")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "footer-bottom-wrapper", attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-row", {
                            staticClass: "footer-states-wrapper",
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1eed0d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1eed0d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/footer.vue
// module id = null
// module chunks = 